import { makeContextModule } from '@cian/react-utils';
import { noop } from '../noop';

export interface IReplyOnboardingState {
  /** Подходит ли сообщение для онбординга (последний свайпабельный таргет на активной странице) */
  isReplyOnboardingTargetMessage: (messageId: string) => boolean;
  /** Завершить онбординг: проставить куку и скрыть */
  complete: VoidFunction;
  /** Онбординг показан */
  onOnboardingShown: VoidFunction;
}

const defaultState: IReplyOnboardingState = {
  isReplyOnboardingTargetMessage: () => false,
  complete: noop,
  onOnboardingShown: noop,
};

export const {
  Context: ReplyOnboardingContext,
  useContext: useReplyOnboardingContext,
  withContext: withReplyOnboardingContext,
} = makeContextModule<IReplyOnboardingState>({
  contextName: 'ReplyOnboardingContext',
  defaultValue: defaultState,
});
